export default [
    {
        path: 'metabase',
        meta: { label: 'Metabase Report', permission: 'access_button_employee_route_report' },
        name: 'metabase',
        component: () => import('./../../views/reports/MetabaseReport.vue'),
    },
]